(function($){ 
  var vat = 20; // VAT rate to use
  
    /* ============================================================= */
    // Cart calcs on page load **** START ****
    /* ============================================================= */
    
    console.log("Fire event!");

    var elSubTotal = $(".js-cart-shipping-subtotal");         
    var elShipping = $(".js-cart-shipping-rate");
    var elVat = $(".js-cart-vat");        
    var elCartTotal = $(".js-cart-total");

    // Handle the sub total
    var subTotal = elSubTotal.text(); 
    subTotal = parsePotentiallyGroupedFloat(subTotal);
    //console.log("newSubTotal is: " + subTotal);

    // Other required vars        
    var calculatedShippingCost;
    var cartTotalExVAT; 
    var cartTotal; 

    var zipCode = $(".shippingZip").text();
    var countryCode = $(".shippingCountry").text();

    $.ajax({  
        type:'post',
        url: "https://www.roofingsuppliesuk.co.uk/cart/shipping_rates.json?shipping_address%5Bzip%5D=SE1+3SY&shipping_address%5Bcountry%5D=United+Kingdom",
        //url: `https://www.roofingsuppliesuk.co.uk/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${countryCode}`,
        dataType: 'json', 
        success: function(result){               
           
            // Calculations
          if(result["shipping_rates"][0]){
            
          
            calculatedShippingCost = result["shipping_rates"][0]["price"];
            console.log("Returned RATE: " + calculatedShippingCost);
            
            cartTotalExVAT = +subTotal + +calculatedShippingCost; // Cart total (ex Vat)
            cartTotal = ((cartTotalExVAT/100) * (vat+100)).toFixed(2); // Calc VAT
            totalVAT = (cartTotal - cartTotalExVAT).toFixed(2);

            // Set values
            elShipping.text(calculatedShippingCost);
            elVat.text(totalVAT);
            elCartTotal.text(cartTotal);
 
          }
        },
        error : function(request,error){
            console.log("====== ERROR AFTER CART UPDATE======");
        }
    }); 

    // The cart and minicart updates
    document.addEventListener('cart:rerendered', function(event) {

        console.log("Fire event!");

        var elSubTotal = $(".js-cart-shipping-subtotal");         
        var elShipping = $(".js-cart-shipping-rate");
        var elVat = $(".js-cart-vat");        
        var elCartTotal = $(".js-cart-total");

        // Handle the sub total
        var subTotal = elSubTotal.text(); 
        subTotal = parsePotentiallyGroupedFloat(subTotal);
        //console.log("newSubTotal is: " + subTotal);

        // Other required vars        
        var calculatedShippingCost;
        var cartTotalExVAT; 
        var cartTotal; 

        var zipCode = $(".shippingZip").text();
        var countryCode = $(".shippingCountry").text();
        
        $.ajax({  
            type:'post',
            url: "https://www.roofingsuppliesuk.co.uk/cart/shipping_rates.json?shipping_address%5Bzip%5D=SE1+3SY&shipping_address%5Bcountry%5D=United+Kingdom",
            //url: `https://www.roofingsuppliesuk.co.uk/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zipCode}&shipping_address%5Bcountry%5D=${countryCode}`,
            dataType: 'json',
            success: function(result){      
              if(result["shipping_rates"][0]){
                
                // Calculations
                calculatedShippingCost = result["shipping_rates"][0]["price"];
                console.log("Returned RATE: " + calculatedShippingCost);
                
                cartTotalExVAT = +subTotal + +calculatedShippingCost; // Cart total (ex Vat)
                cartTotal = ((cartTotalExVAT/100) * (vat+100)).toFixed(2); // Calc VAT
                totalVAT = (cartTotal - cartTotalExVAT).toFixed(2);

                // Set values
                elShipping.text(calculatedShippingCost);
                elVat.text(totalVAT);
                elCartTotal.text(cartTotal);
              }               

            },
            error : function(request,error){
                console.log("====== ERROR AFTER CART UPDATE======");
            }
        }); 
    });
  
    function parsePotentiallyGroupedFloat(stringValue) {
        stringValue = stringValue.trim();
        var result = stringValue.replace(/[^0-9]/g, '');
        if (/[,\.]\d{2}$/.test(stringValue)) {
            result = result.replace(/(\d{2})$/, '.$1');
        }
        return parseFloat(result);
    }
})(jQuery);  